import type {CountryCode} from 'libphonenumber-js'
import type {RefObject} from 'react'

import {t} from '../../../../../lib/utils/localization'
import {SearchableSelector} from '../SearchableSelector/SearchableSelector'
import styles from './PhoneInputWithCountrySearch.module.css'
import {filterCountriesBySearch, getCountryDisplayShort, type CountryOption} from './phone-utils'

type CountrySearchableSelectorProps = {
  id: string
  countries: CountryOption[]
  selectedCountry: CountryCode
  onSelect: (code: CountryCode) => void
  nextFocusRef?: RefObject<HTMLElement | null>
}

export function CountrySearchableSelector({
  id,
  countries,
  selectedCountry,
  onSelect,
  nextFocusRef,
}: CountrySearchableSelectorProps) {
  return (
    <SearchableSelector
      id={`${id}-country`}
      items={countries}
      selectedItemKey={selectedCountry}
      getItemKey={country => country.code}
      filterItems={filterCountriesBySearch}
      onSelect={country => onSelect(country.code)}
      renderTriggerContent={country => (country ? getCountryDisplayShort(country.code) : '')}
      getTriggerAriaLabel={country => {
        const selectedCountryDisplay = country ? getCountryDisplayShort(country.code) : ''
        return `${t('Select country for phone number. Currently selected:')} ${selectedCountryDisplay}`
      }}
      renderItem={({item}) => (
        <>
          <span className={styles.countryOptionName}>{item.name}</span>
          <span className={styles.countryOptionCallingCode}>(+{item.callingCode})</span>
        </>
      )}
      searchInputAriaLabel={t('Search countries')}
      searchInputPlaceholder={t('Search countries...')}
      listboxAriaLabel={t('Countries')}
      noResultsMessage={t('No countries found')}
      nextFocusRef={nextFocusRef}
      triggerClassName={styles.countryTrigger}
    />
  )
}
